"use client";
import AcademicCard from "@/components/layout/Academiccard";

const AcademicCards = ({ data }) => {
  return (
    <div className="mt-6 grid grid-cols-2 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {data?.map((item, i) => (
        <AcademicCard key={item?.id ?? i} item={item} />
      ))}
    </div>
  );
};

export default AcademicCards;